import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Toast } from "../../CustomComponent/toast";

const AssignTrainingTests = () => {
  const [employees, setEmployees] = useState([]);

  const [employeeId, setEmployeeId] = useState("");
  const [dueDate, setDueDate] = useState("");

  const [errors, setErrors] = useState({});

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setEmployees(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const validate = () => {
    const newErrors = {};

    if (!employeeId) newErrors.employeeId = "Employee is required";
    if (!dueDate) newErrors.dueDate = "Due date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = {
      employeeId,
      dueDate,
    };

    // await axios.post("/training/assign-tests", payload);
    await performRequest("POST", "/test/create-test-for-trainee", payload)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Tests assigned successfully.");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          Toast("error", "Test already  assigned.");
          // navigate("/my-scoreboard");
        } else if (err?.response?.status === 409) {
          Toast("error", "Test already attempted.");
        } else {
          CustomErrorResponse(err);
        }
      });

    // Reset
    setEmployeeId("");
    setDueDate("");
    setErrors({});
  };

  return (
    <div className="Page">
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xxl">
            <div className="card p-4">
              <h3 className="mb-4">Assign Training Tests</h3>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Employee */}
                  <div className="mb-3 col-12 col-md-6 col-lg-4">
                    <label className="form-label">Employee *</label>
                    <select
                      className="form-control"
                      value={employeeId}
                      onChange={(e) => setEmployeeId(e.target.value)}
                    >
                      <option value="">Select Employee</option>
                      {employees.map((emp) => (
                        <option key={emp.id} value={emp.id}>
                          {emp.userName}
                        </option>
                      ))}
                    </select>
                    {errors.employeeId && (
                      <small className="text-danger">{errors.employeeId}</small>
                    )}
                  </div>

                  {/* Due Date */}
                  <div className="mb-3 col-12 col-md-6 col-lg-4">
                    <label className="form-label">Due Date *</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                    />
                    {errors.dueDate && (
                      <small className="text-danger">{errors.dueDate}</small>
                    )}
                  </div>
                </div>

                {/* Button */}
                <div className="mt-3">
                  <button className="btn btn-primary px-4" type="submit">
                    Assign Tests
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignTrainingTests;
